export const List = () => import('./List.vue');
export const Create = () => import('./Create.vue');
export const Edit = () => import('./Edit.vue');
export const View = () => import('./View.vue');
export const PreSanction = () => import('./PreSanction.vue');
export const NoteSheet = () => import('./NoteSheet.vue');
export const JournalNoteSheet = () => import('./JournalNoteSheet.vue');

export const DailyCash = () => import('./DailyCash.vue');
export const DailyCashEntry = () => import('./DailyCashCreate.vue');